import {ReactNode} from "react";

interface TipsPerTransportTypeProps {
    title?: string | ReactNode,
    subtitle?: string | ReactNode,
    options: { option: string | ReactNode, id: string }[],
}

function TipsPerTransportType({title, subtitle, options}: TipsPerTransportTypeProps) {
    return (
        <>
            {!!title && (
                <h3>{title}</h3>
            )}
            {!!subtitle && (
                <h3>{subtitle}</h3>
            )}
            <ul>
                {options.map(({option, id}) => (
                    <li key={id}>
                        {option}
                    </li>
                ))}
            </ul>
        </>
    )
}

export default TipsPerTransportType